export const config = _sys => {
  return {
    jwtAdapter: 'home-api:jwtAdapter',
    authToken: {
      default: true
    }
  };
};